<script>
  import CustomerRow from './CustomerRow.svelte';
  import { onMount } from 'svelte';
  import {
    searchedCustomer,
    searchedCustomerByDateStart,
    searchedCustomerByDateEnd,
    isLoggedIn,
  } from '../../utils/store.js';
  import { navigateTo } from 'svelte-router-spa';
  import moment from 'moment';

  let customers = [];

  $: nameOrPhoneNumberOrDistrictMatchesReactive = (customer) => {
    let isNameMatches = customer.name.match(
      RegExp($searchedCustomer.toLocaleUpperCase('tr-TR'), 'i')
    );
    let isPhoneNumberMatches = customer.phoneNumber.match(
      new RegExp($searchedCustomer, 'i')
    );

    customer.additionalPhoneNumbers.forEach((number) => {
      if (number.phoneNumber.match(RegExp($searchedCustomer, 'i'))) {
        isPhoneNumberMatches = true;
      }
    });

    let isDistrictMatches = customer.district.match(
      RegExp($searchedCustomer.toLocaleUpperCase('tr-TR'), 'i')
    );

    return isNameMatches || isPhoneNumberMatches || isDistrictMatches;
  };

  $: dateMatchesReactive = (customer) => {
    if ($searchedCustomerByDateStart && $searchedCustomerByDateEnd) {
      return moment(customer.callDate).isBetween(
        $searchedCustomerByDateStart,
        $searchedCustomerByDateEnd
      );
    }

    return true;
  };

  async function getCustomers() {
    const response = await fetch(process.env.BACKEND_URL + 'customers', {
      method: 'GET',
      credentials: 'include',
    });

    if (response.ok) {
      customers = await response.json();
    } else {
      isLoggedIn.set(false);
      navigateTo('/login');
    }
  }

  onMount(getCustomers);
</script>

<div class="text-center container mt-4 mb-2"><b>Toplam Müşteri Sayısı: </b> {customers.length}</div>

<table class="table container">
  <thead>
    <tr>
      <th scope="col">Telefon Numarası</th>
      <th scope="col">İsim</th>
      <th scope="col">İlçe</th>
      <th scope="col">Arama Tarihi</th>
    </tr>
  </thead>
  <tbody>
    {#each customers as customer}
      {#if nameOrPhoneNumberOrDistrictMatchesReactive(customer) && dateMatchesReactive(customer)}
        <CustomerRow {customer} />
      {/if}
    {/each}
  </tbody>
</table>
